import {FC} from "react";

export const PlayIcon: FC = () => {
    return (
        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 2.53047V18.4695C0 20.1878 2.35478 21.1264 3.9058 20.0264L15.1432 12.0569C16.2856 11.2466 16.2856 9.75335 15.1432 8.94313L3.90579 0.973594C2.35478 -0.126387 0 0.812249 0 2.53047Z" fill="#909090"/>
        </svg>
    )
}import {FC} from "react";

export const PlayIcon: FC = () => {
    return (
        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 2.53047V18.4695C0 20.1878 2.35478 21.1264 3.9058 20.0264L15.1432 12.0569C16.2856 11.2466 16.2856 9.75335 15.1432 8.94313L3.90579 0.973594C2.35478 -0.126387 0 0.812249 0 2.53047Z" fill="#909090"/>
        </svg>
    )
}